









import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class Loader extends Vue {
    @Prop() text!: string;
    @Prop() extraClass!: string;
}
